import React from "react";
import { Quote } from "lucide-react";

interface QuotePreviewProps {
    text: string;
    onClick?: () => void;
}

const QuotePreview: React.FC<QuotePreviewProps> = ({ text, onClick }) => {
    // Truncate text if it's too long
    const displayText = text.length > 200 ? text.substring(0, 200) + "..." : text;

    return (
        <div
            className="quote-preview flex items-start gap-3 p-3 mb-2 bg-violet-50/50 border-l-4 border-violet-500 rounded-r-lg cursor-pointer hover:bg-violet-100/50 transition-all duration-200 transform hover:-translate-y-0.5 w-full max-w-full"
            onClick={onClick}
        >
            <div className="flex flex-col w-full">
                <div className="text-xs font-semibold text-violet-700 mb-1 flex items-center gap-1">
                    <Quote size={12} className="fill-violet-700" />
                    Replying to selection
                </div>
                <p className="text-sm text-gray-600 italic line-clamp-3 break-words text-left pl-1">
                    "{displayText}"
                </p>
            </div>
        </div>
    );
};

export default QuotePreview;
